// Japanese translations
export const ja = {
  // Navigation
  'nav.overview': '概要',
  'nav.dashboard': 'ダッシュボード',
  'nav.analytics': '分析',
  'nav.reportingDashboard': 'レポートダッシュボード',
  'nav.sales': '売上',
  'nav.salesOrders': '販売オーダー',
  'nav.purchase': '購買',
  'nav.purchaseOrders': '発注',
  'nav.purchaseReview': '審査ワークスペース',
  'nav.purchase.sprints': 'スプリント',
  'nav.supplierOnboarding': 'サプライヤーオンボーディング',
  'nav.po': 'PO',
  'nav.po.sprints': 'スプリント',
  'nav.po.newSprint': 'スプリントを作成',
  'nav.scout': 'スカウト',
  'nav.scout.wochenplanung': '週間計画',
  'nav.scout.tagesplanung': '日次計画',
  'nav.scout.prequal': 'PreQual コール',
  'nav.scout.missionen': 'ミッション',
  'nav.scout.missionControl': 'ミッションコントロール',
  'nav.scout.unternehmenssuche': '企業検索',
  'nav.scout.preferences': '設定',
  'nav.scout.hilfe': 'ヘルプ',
  'nav.scout.scorecard': 'スコアカード',
  'nav.poSprints': 'PO/スプリント',
  'nav.wiki': 'ウィキ',
  'nav.supportVisualization': 'サポート可視化',
  'nav.navigationTiles': 'ナビゲーションタイル',
  'nav.styleGuide': 'スタイルガイド',
  'nav.inventory': '在庫',
  'nav.items': '品目',
  'nav.warehouse': '倉庫',
  'nav.picking': 'ピッキング',
  'nav.asn': 'ASN',
  'nav.returns': '返品',
  'nav.accounting': '会計',
  'nav.accountsReceivable': '売掛金',
  'nav.crm': '顧客管理',
  'nav.leads': 'リード',
  'nav.contacts': '連絡先',
  'nav.ai': 'AI',
  'nav.commandCenter': 'コマンドセンター',
  'nav.workflows': 'ワークフロー',
  'nav.workflowManagement': 'ワークフロー管理',
  'nav.projectManagement': 'プロジェクト管理',
  'nav.support': 'サポート',
  'nav.tickets': 'チケット',
  'nav.pivotTable': 'ピボットテーブル',
  'nav.learning': '学習',
  'nav.curriculumPlanning': 'カリキュラム計画',
  'nav.learnerDashboard': '学習者ダッシュボード',
  'nav.accessibleLearnerDashboard': 'アクセシブル学習者ダッシュボード',
  'nav.settings': '設定',
  'nav.general': '一般',
  'nav.company': '会社',
  'nav.addressManagement': '住所管理',
  'nav.usersRoles': 'ユーザーとロール',
  'nav.auditLog': '監査ログ',
  'nav.integrations': '連携',
  'nav.appOverview': 'アプリ概要',
  'nav.appOverviewDescription': 'アプリをクリックして移動するか、タイルをドラッグして並べ替えてください',
  'header.help': 'ヘルプ',
  'header.account': 'アカウント',
  'header.portalName': 'CLANDAポータル',
  'header.preferences': '設定',
  'header.language': '言語',

  // Help page

  // Privacy page

  // Form

  // Placeholders

  // Status

  // Actions
  'action.delete': '削除',

  // Messages
  'message.success': '成功',
  'message.error': 'エラー',

  // Common
  'common.yes': 'はい',
  'common.no': 'いいえ',
  'common.cancel': 'キャンセル',
  'common.confirm': '確認',
  'common.save': '保存',
  'common.saveChanges': '変更を保存',
  'common.close': '閉じる',
  'common.reset': 'リセット',
  'common.back': '戻る',
  'common.loading': '読み込み中...',
  'common.search': '検索',
  'common.search.placeholder': '検索...',
  'common.filter': 'フィルター',
  'common.sort': '並び替え',
  'common.add': '追加',
  'common.delete': '削除',
  'common.edit': '編集',
  'common.error': 'エラー',
  'common.remove': '削除',
  'common.minutesShort': '{{value}} 分',
  'common.na': '該当なし',
  'common.days': '日',
  'common.status.active': '有効',
  'common.status.paused': '一時停止',
  'common.status.stopped': '停止',
  'common.status.pending': '保留',
  'common.status.completed': '完了',
  'common.status.planned': '予定',
  'common.status.inProgress': '進行中',
  'common.status.done': '完了',
  'common.apply': '適用',
  'common.actions.filter': 'フィルター',
  'common.actions.export': 'エクスポート',
  'common.actions.search': '検索',
  'common.dialog.defaultTitle': 'ダイアログ',
  'common.all': 'すべて',
  'common.total': '合計',
  'common.pending': '保留',
  'common.assigned': '割り当て済み',
  'common.inProgress': '進行中',
  'common.completed': '完了',
  'common.cancelled': 'キャンセル',
  'common.approved': '承認済み',
  'common.rejected': '却下',
  'common.processing': '処理中',
  'common.overdue': '期限超過',
  'common.partial': '一部',
  'common.highPriority': '高優先',
  'common.tableView': 'テーブル表示',
  'common.cardView': 'カード表示',
  'common.switchToTable': 'テーブル表示に切替',
  'common.switchToCard': 'カード表示に切替',
  'common.openMenu': 'メニューを開く',
  'common.details': '詳細',
  'common.overview': '概要',
  'common.new': '新規',
  'common.draft': '下書き',
  'common.shipped': '発送済み',
  'common.delivered': '配達済み',
  'common.received': '受取済み',
  'common.inTransit': '配送中',
  'common.itemsPicked': 'ピッキング済み',
  'common.totalRefund': '返金合計',
  'common.totalPrice': '合計金額',
  'common.orderSummary': '注文概要',
  'common.subtotal': '小計:',
  'common.tax': '税:',
  'common.discount': '割引:',
  'common.totalColon': '合計:',

  // Date Range Filter (canonical component)
  'dateRange.today': '今日',
  'dateRange.yesterday': '昨日',
  'dateRange.last7Days': '過去7日間',
  'dateRange.last14Days': '過去14日間',
  'dateRange.last30Days': '過去30日間',
  'dateRange.thisMonth': '今月',
  'dateRange.custom': 'カスタム',

  // Dashboard
  'widget.vsLastPeriod': '前期比',
  'table.showing': '表示中',
  'table.of': '／',
  'table.page': 'ページ',
  'table.previous': '前へ',
  'table.next': '次へ',
  'table.filterGroups': 'フィルターグループ',
  'table.addFilterGroup': 'フィルターグループを追加',
  'table.filterGroup': 'フィルターグループ',
  'table.addCondition': '条件を追加',
  'table.operator': '演算子',
  'table.field': 'フィールド',
  'table.noFilterGroups': 'フィルターグループがありません。',
  'filter.operator.equals': '等しい',
  'filter.operator.not_equals': '等しくない',
  'filter.operator.contains': '含む',
  'filter.operator.not_contains': '含まない',
  'filter.operator.starts_with': 'で始まる',
  'filter.operator.ends_with': 'で終わる',
  'filter.operator.gt': 'より大きい',
  'filter.operator.lt': 'より小さい',
  'filter.operator.gte': '以上',
  'filter.operator.lte': '以下',
  'filter.operator.between': '範囲内',
  'filter.operator.in': 'いずれかに一致',
  'filter.operator.not_in': 'いずれにも不一致',
  'filter.operator.is_set': '設定済み',
  'filter.operator.is_not_set': '未設定',
  'filter.placeholder.value': '値',
  'filter.placeholder.min': '最小',
  'filter.placeholder.max': '最大',
  'filter.placeholder.select': '選択…',
  'filter.placeholder.selectMultiple': '複数選択…',
  'filter.logic.and': 'かつ',
  'filter.logic.or': 'または',

  // Documents

  // Validation

  // Toasts

  // Reviewer Dashboard

  // Account / Settings
  'settings.title': 'アカウント設定',

  // Consent
  'consent.title': '同意',
  'consent.label': '利用規約と発注ポリシーに同意します',
  'consent.description': '規約を読み、同意しました。',
  'consent.required': '規約に同意してください。',
  'consent.link.terms': '規約',

  // Contacts
  'contacts.title': '連絡先',
  'contacts.role': 'ロール',
  'contacts.role.admin': '管理者',
  'contacts.role.billing': '請求',
  'contacts.role.technical': '技術',
  'contacts.role.other': 'その他',

  // ARIA / Accessibility

  // Auth
  'auth.callback.title': '認証',

  // Debug

  // Deliveries

  // SKU Mappings

  // PO List

  // PO Sprints

  // Terms page

  // Common UI Elements

  // Dashboard

  // AI Command Center

  // Learning & Development
  'learning.feed.greeting': 'こんにちは {{name}} さん！',
  'learning.feed.levelInfo': 'レベル {{level}}・{{xp}} XP',
  'learning.feed.offline': 'オフライン',
  'learning.feed.streakLabel': '日連続',
  'learning.feed.dailyGoal': '本日の目標',
  'learning.feed.recommendedLessons': 'おすすめレッスン',
  'learning.feed.priority.high': '高',
  'learning.feed.priority.medium': '中',
  'learning.feed.priority.low': '低',
  'learning.feed.difficulty.easy': 'かんたん',
  'learning.feed.difficulty.medium': '普通',
  'learning.feed.difficulty.hard': '難しい',
  'learning.feed.aiRecommendation': 'AIおすすめ',
  'learning.feed.actions.start': '開始',
  'learning.feed.actions.skip': 'スキップ',
  'learning.feed.actions.reload': '再読み込み',
  'learning.feed.empty.title': 'すべてのレッスンが完了しました！',
  'learning.feed.empty.description': '本日利用可能なレッスンはすべて完了しました。また明日お越しください。',
  'learning.quiz.title': 'クイズ',
  'learning.quiz.questionCounter': '問題 {{current}} / {{total}}',
  'learning.quiz.options.true': '正',
  'learning.quiz.options.false': '誤',
  'learning.quiz.actions.next': '次へ',
  'learning.quiz.actions.finish': '終了',
  'learning.quiz.actions.retry': '再挑戦',
  'learning.quiz.badge.xp': '{{xp}} XP',
  'learning.quiz.badge.time': '{{seconds}}秒',
  'learning.quiz.result.passedTitle': 'クイズ合格！',
  'learning.quiz.result.failedTitle': 'クイズ不合格',
  'learning.quiz.result.scoreSummary': '{{correct}} / {{total}} 正解',
  'learning.quiz.result.xpEarned': '+{{xp}} XP 獲得',
  'learning.quiz.result.answersHeading': '解答詳細',
  'learning.quiz.result.questionLabel': '問題 {{index}}',
  'learning.quiz.result.yourAnswer': 'あなたの回答',
  'learning.quiz.result.correctAnswer': '正解',
  'learning.lessonCard.difficulty.easy': 'かんたん',
  'learning.lessonCard.difficulty.medium': '普通',
  'learning.lessonCard.difficulty.hard': '難しい',
  'learning.lessonCard.status.completed': '完了',
  'learning.lessonCard.reward': '報酬',
  'learning.lessonCard.progress': '進捗',
  'learning.lessonCard.selectFormat': '形式を選択',
  'learning.lessonCard.prerequisites': '前提条件',
  'learning.lessonCard.actions.start': '開始',
  'learning.lessonCard.actions.repeat': '繰り返し',
  'learning.lessonCard.actions.pause': '一時停止',
  'learning.lessonCard.actions.complete': '完了',
  'learning.lessonCard.actions.bookmark': 'ブックマーク',
  'learning.lessonCard.actions.unbookmark': 'ブックマーク解除',
  'learning.lessonCard.actions.collapse': '折りたたむ',
  'learning.lessonCard.actions.expand': '展開',
  'learning.lessonCard.goalLabel': '目標',
  'learning.lessonCard.formats.video': '動画を見る',
  'learning.lessonCard.formats.text': 'テキストを読む',
  'learning.lessonCard.formats.audio': '音声を聴く',
  'learning.lessonCard.formats.cheatSheet': 'チートシート',
  'learning.lessonCard.formatUnknown': '不明',
  'learning.accessible.title': '学習ダッシュボード',
  'learning.accessible.welcome': 'おかえりなさい、{{name}} さん',
  'learning.accessible.voice.start': '音声',
  'learning.accessible.voice.stop': '音声操作を終了',
  'learning.accessible.voice.listening': '聞いています...',
  'learning.accessible.level': 'レベル',
  'learning.accessible.xpToNext': '次のレベルまで {{value}} XP',
  'learning.accessible.streak': '連続',
  'learning.accessible.days': '{{value}} 日',
  'learning.accessible.keepItUp': 'その調子！',
  'learning.accessible.badges': 'バッジ',
  'learning.accessible.achievementsEarned': '実績',
  'learning.accessible.tabs.overview': '概要',
  'learning.accessible.tabs.lessons': 'レッスン',
  'learning.accessible.tabs.progress': '進捗',
  'learning.accessible.tabs.achievements': '実績',
  'learning.accessible.recentActivity': '最近のアクティビティ',
  'learning.accessible.noRecentActivity': 'アクティビティはありません',
  'learning.accessible.start': '開始',
  'learning.accessible.learningProgress': '学習進捗',
  'learning.accessible.overallProgress': '全体の進捗',
  'learning.accessible.achievements': '実績',
  'learning.accessible.startingLesson': 'レッスン {{id}} を開始',
  'learning.accessible.difficulty.beginner': '初級',
  'learning.accessible.difficulty.intermediate': '中級',
  'learning.accessible.difficulty.advanced': '上級',
  'gamification.xpToast.xpLabel': 'XP',
  'gamification.xpToast.streakProgress': '連続進捗',
  'gamification.xpToast.streakProgressValue': '{{current}} / {{target}}',
  'gamification.xpToast.source.lesson': 'レッスン',
  'gamification.xpToast.source.quiz': 'クイズ',
  'gamification.xpToast.source.streak': '連続',
  'gamification.xpToast.source.badge': 'バッジ',
  'gamification.xpToast.source.bonus': 'ボーナス',
  'gamification.xpToast.levelUp.title': 'レベルアップ！',
  'gamification.xpToast.levelUp.description': 'レベル {{level}} に到達しました！',
  'gamification.xpToast.levelUp.xpEarned': '+{{xp}} XP 獲得',
  'gamification.xpToast.button.continue': '続ける',
  'gamification.xpToast.streakMilestone.title': '連続マイルストーン！',
  'gamification.xpToast.streakMilestone.description': '{{count}} 日連続達成！',
  'gamification.xpToast.streakMilestone.bonus': '+{{xp}} XP ボーナス獲得',
  'gamification.close': '閉じる',

  // Wissensdatenbank
  'knowledgeBase.back': '戻る',
  'knowledgeBase.article.view': '表示',
  'knowledgeBase.article.views': '{{count}} 閲覧',
  'knowledgeBase.article.helpful': '{{count}} 役に立った',
  'knowledgeBase.article.notHelpful': '{{count}} 役に立たなかった',
  'knowledgeBase.article.byAuthor': '著者: {{author}}',
  'knowledgeBase.header.title': 'ナレッジベース',
  'knowledgeBase.header.subtitle': '質問の答えを探す',
  'knowledgeBase.actions.filter': 'フィルター',
  'knowledgeBase.actions.sort': '並び替え',
  'knowledgeBase.search.placeholder': 'ナレッジベースを検索...',
  'knowledgeBase.tabs.all': 'すべて',
  'knowledgeBase.stats.popular': '人気の記事',
  'knowledgeBase.stats.viewsCount': '{{count}} 閲覧',
  'knowledgeBase.stats.helpful': '役に立った記事',
  'knowledgeBase.stats.ratingsCount': '{{count}} 評価',
  'knowledgeBase.stats.total': '記事合計',
  'knowledgeBase.stats.totalCount': '{{count}} 記事',
  'knowledgeBase.empty.title': '記事が見つかりません',
  'knowledgeBase.empty.searching': '別のキーワードを試すか、カテゴリを確認してください。',
  'knowledgeBase.empty.default': 'このカテゴリにはまだ記事がありません。',
  'knowledgeBase.difficulty.beginner': '初級',
  'knowledgeBase.difficulty.intermediate': '中級',
  'knowledgeBase.difficulty.advanced': '上級',
  'knowledgeBase.categories.odoo-basics': 'Odoo 基礎',
  'knowledgeBase.categories.crm': 'CRM・営業',
  'knowledgeBase.categories.inventory': '在庫・購買',
  'knowledgeBase.categories.accounting': '会計',
  'knowledgeBase.categories.projects': 'プロジェクト管理',
  'knowledgeBase.categories.troubleshooting': 'トラブルシューティング',

  // Accounting

  // Curriculum Planning
  'curriculum.video': '動画',
  'curriculum.videoDescription': '画面録画または実践動画',
  'curriculum.cheatSheet': 'チートシート',
  'curriculum.cheatSheetDescription': '印刷用・QRコード付き',
  'curriculum.test': 'テスト/クイズ',
  'curriculum.testDescription': 'Odoo アンケート、10問、80%',
  'curriculum.checklist': 'チェックリスト',
  'curriculum.checklistDescription': 'Odoo タスク、クリック可能',
  'curriculum.textLesson': 'テキスト/レッスン',
  'curriculum.textLessonDescription': 'Odoo コースレッスン',
  'curriculum.roleplay': 'ロールプレイ',
  'curriculum.roleplayDescription': 'メンターとライブ',
  'curriculum.practice': '実践課題',
  'curriculum.practiceDescription': '顧客先で実施',

  // UI Components

  // Purchase Onboarding (wizard)

  // SCOUT - Wochenplanung
  'scout.wochenplanung.title': '週間概要',
  'scout.wochenplanung.previousWeek': '前の週',
  'scout.wochenplanung.nextWeek': '次の週',
  'scout.wochenplanung.toast.appointmentAdded': '予定を追加しました',
  'scout.wochenplanung.toast.appointmentAddedDesc': '{{title}} — {{day}}',
  'scout.wochenplanung.toast.appointmentUpdated': '予定を更新しました',
  'scout.wochenplanung.toast.appointmentUpdatedDesc': '{{title}} — {{day}}',
  'scout.wochenplanung.toast.appointmentDeleted': '予定を削除しました',
  'scout.wochenplanung.toast.slotUpdated': 'スロットを更新しました',
  'scout.wochenplanung.toast.slotUpdatedDesc': 'ミッション解決またはスロット削除。',
  'scout.wochenplanung.legend.completed': '完了',
  'scout.wochenplanung.legend.planned': '予定済み',
  'scout.wochenplanung.legend.partial': '一部予定',
  'scout.wochenplanung.legend.unplanned': '未計画',
  'scout.wochenplanung.legend.holiday': '祝日・休暇',
  'scout.wochenplanung.dialog.deleteAppointment.title': '予定を削除',
  'scout.wochenplanung.dialog.deleteAppointment.description': 'この予定を削除してもよろしいですか？この操作は取り消せません。',
  'scout.wochenplanung.dialog.editAppointment.title': '予定を編集',
  'scout.wochenplanung.dialog.editAppointment.description': 'この予定の変更を保存しますか？',
  'scout.wochenplanung.employee': '担当者',
  'scout.wochenplanung.selectEmployee': '担当者を選択',
  'scout.wochenplanung.allEmployees': '全担当者',
  'scout.wochenplanung.error.loading': '週間計画の読み込みに失敗しました',
  'scout.wochenplanung.error.retry': '再試行',

  // SCOUT - Mission list empty state & actions
  'scout.missions.industries.placeholder': '業種を選択',
  'scout.missions.industries.search': '業種を検索...',
  'scout.missions.industries.empty': '業種が見つかりません',
  'scout.missions.products.placeholder': '製品ファミリーを選択',
  'scout.missions.products.search': '製品ファミリーを検索...',
  'scout.missions.products.empty': '製品ファミリーが見つかりません',
  'scout.missionControl.tabs.team': 'チーム概要',
  'scout.missionControl.teamMembers': 'チームメンバー',
  'scout.missionControl.table.employee': '担当者',
  'scout.missionControl.table.team': 'チーム',
  'scout.missionControl.table.plzAreas': '郵便番号エリア',

  // SCOUT - Missionen
  'scout.missionen.bestandskunden.loadError': '既存顧客の読み込みに失敗しました',
  'scout.missionen.bestandskunden.empty': '既存顧客が見つかりません',
  'scout.missionen.bestandskunden.search': '既存顧客を検索...',
  'scout.missionen.bestandskunden.filteredCount': '{{total}} 件中 {{filtered}} 件の既存顧客',
  'scout.missionen.wunschliste.industriesTitle': '希望業種',
  'scout.missionen.wunschliste.productsTitle': '希望製品',
  'scout.missionen.wunschliste.plzTitle': '希望郵便番号エリア',
  'scout.missionen.wunschliste.saveButton': '保存',
  'scout.missionen.wunschliste.saved': '保存しました',
  'scout.missionen.wunschliste.savedDesc': '設定を保存しました。',
  'scout.missionen.wunschliste.saveError': 'エラー',
  'scout.missionen.wunschliste.saveErrorDesc': '設定を保存できませんでした。',
  'scout.missionen.wunschliste.loadError': '設定の読み込みに失敗しました',
  'scout.tagesplanung.title': '日次計画',
  'scout.tagesplanung.addressUnknown': '住所不明',
  'scout.tagesplanung.routeMapLabel': 'ルート地図',
  'scout.tagesplanung.routePlanning': 'ルート計画',
  'scout.tagesplanung.traffic': '交通',
  'scout.tagesplanung.deferNotPossible': '先送りできません',
  'scout.tagesplanung.deferMaxReached': '本日の先送り上限に達しました（3/3）。',
  'scout.tagesplanung.deferAlreadyDeferred': 'このリードは本日すでに先送り済みです。',
  'scout.tagesplanung.dayCannotClose': '日を閉じられません',
  'scout.tagesplanung.outstandingReports': '未入力の訪問レポートが {{count}} 件あります。日を閉じる前にすべて入力してください。',
  'scout.tagesplanung.andMore': '... 他 {{count}} 件',
  'scout.tagesplanung.tabs.planning': '日次プラン',
  'scout.tagesplanung.tasks.tabLabel': 'タスク',
  'scout.tagesplanung.tasks.empty': 'タスクはありません',
  'scout.tagesplanung.tasks.loading': 'タスクを読み込み中',
  'scout.tagesplanung.tasks.error': 'タスクを読み込めませんでした',
  'scout.tagesplanung.tasks.filterFieldStatus': 'ステータス',
  'scout.tagesplanung.tasks.filterStatusTodo': '未着手',
  'scout.tagesplanung.tasks.filterStatusInProgress': '進行中',
  'scout.tagesplanung.tasks.filterStatusDone': '完了',
  'scout.tagesplanung.tasks.priorityLabel': '優先度',
  'scout.tagesplanung.tasks.priorityValue': '{{value}}',
  'scout.tagesplanung.tasks.priorityUnknown': '—',
  'scout.tagesplanung.tasks.dueLabel': '期限',
  'scout.tagesplanung.tasks.dueNone': '期限なし',
  'scout.lead.neukunde': '新規 — ニッチ製品を切り口に',
  'scout.lead.bestandskunde': '既存顧客',
  'scout.metrics.besuche': '訪問',
  'scout.metrics.demos': 'デモ',
  'scout.metrics.auftraege': '受注',
  'scout.metrics.umsatz': '売上',
  'scout.metrics.demoRate': 'デモ率',
  'scout.composition.title': 'ミッション構成',
  'scout.composition.minBestandskunden': '最小既存顧客',
  'scout.composition.minQualifiziert': '最小認定リード',
  'scout.composition.maxKaltbesuche': '最大コールド訪問',
  'scout.dailyPlanning.addAppointment': '予定を追加',
  'scout.dailyPlanning.appointments': '予定',
  'scout.dailyPlanning.noAppointmentsPlanned': 'この日の予定はありません',
  'scout.dailyPlanning.leadsByPriority': 'リード（優先度順）',
  'scout.dailyPlanning.noLeadsPlanned': 'この日のリードはありません',
  'scout.dailyPlanning.skipLead': 'リードをスキップ',
  'scout.dailyPlanning.skipLeadConfirmation': 'このリードをスキップしますか？翌日に繰り越されます。',
  'scout.dailyPlanning.skip': 'スキップ',
  'scout.dailyPlanning.removeLead': 'リードを削除',
  'scout.dailyPlanning.removeLeadConfirmation': 'このリードを削除しますか？ローテーションから完全に外れます。',
  'scout.dailyPlanning.selectMissionToViewLeads': 'リードを表示するミッションを選択',
  'scout.dailyPlanning.selectDate': '日付を選択',
  'scout.dailyPlanning.nextDay': '翌日',
  'scout.dailyPlanning.closeDay': '日を閉じる',
  'scout.dailyPlanning.reopenDay': '日を再開する',
  'scout.dailyPlanning.noAcceptedLeads': 'この日の受諾リードがありません。',
  'scout.dailyPlanning.statusSkipped': 'スキップ済み',
  'scout.dailyPlanning.selectAll': 'すべて選択',
  'scout.dailyPlanning.selectAllLeads': 'すべてのリードを選択',
  'scout.dailyPlanning.noSuggestions': '提案なし。',
  'scout.dailyPlanning.previousDay': '前日',
  'scout.dailyPlanning.calendarWeek': '第 {{weekNumber}} 週',
  'scout.dailyPlanning.visit': '訪問',
  'scout.dailyPlanning.details': '詳細',
  'scout.dailyPlanning.missionsLoading': 'ミッションを読み込み中…',
  'scout.dailyPlanning.leadsLoading': 'リードを読み込み中…',
  'scout.dailyPlanning.noLeadsFound': 'リードが見つかりません',
  'scout.dailyPlanning.moreLeads': 'さらに',
  'scout.dailyPlanning.dailyList': '日次リスト',
  'scout.dailyPlanning.unknown': '不明',
  'scout.dailyPlanning.suggestedLeads': '提案リード',
  'scout.dailyPlanning.error': 'エラー: {{error}}',
  'scout.dailyPlanning.help': 'ヘルプ',
  'scout.dailyPlanning.bulkActions': '一括操作',
  'scout.dailyPlanning.actionsCount': '操作（{{count}}）',
  'scout.dailyPlanning.accept': '受諾',
  'scout.dailyPlanning.reject': '拒否',
  'scout.dailyPlanning.selectLead': 'リード {{name}} を選択',
  'scout.dailyPlanning.openLeadDetails': '{{name}} の詳細を開く',
  'scout.dailyPlanning.score': 'スコア: {{score}}',
  'scout.dailyPlanning.loading': '日次計画を読み込み中',
  'scout.dailyPlanning.inField': '外勤中',
  'scout.dailyPlanning.completed': '完了',
  'scout.dailyPlanning.openDay': '日を開く',
  'scout.dailyPlanning.dayMarkedCompleted': 'この日は完了済みです。',
  'scout.dailyPlanning.statusVisited': '訪問済み',
  'scout.dailyPlanning.statusPlanned': '予定',
  'scout.dailyPlanning.statusCompleted': '完了',
  'scout.scorecard.selectHeatmapMetric': 'ヒートマップの指標を選択',
  'scout.scorecard.orders': '受注',
  'scout.scorecard.annualTargetOrders': '年間受注目標',
  'scout.scorecard.comingSoon': '近日公開',
  'scout.scorecard.kpiOverview': 'KPI概要・アクティビティ・主要業種',
  'scout.scorecard.activityByDay': '日別アクティビティ',
  'scout.scorecard.title': 'スコアカード',
  'scout.scorecard.period.tag': '日',
  'scout.scorecard.period.woche': '週',
  'scout.scorecard.period.monat': '月',
  'scout.scorecard.period.jahr': '年',
  'scout.scorecard.kpiTilesHeading': 'KPIタイル',
  'scout.scorecard.topBranchenProdukteHeading': '主要業種・主要製品',
  'scout.scorecard.soll': '目標',
  'scout.scorecard.forecast': '予測',
  'scout.scorecard.gapToGo': '残差',
  'scout.scorecard.csvExport': 'CSVエクスポート',
  'scout.scorecard.pdfExport': 'PDFエクスポート',
  'scout.scorecard.table.date': '日付',
  'scout.scorecard.table.visits': '訪問',
  'scout.scorecard.table.demos': 'デモ',
  'scout.scorecard.table.orders': '受注',
  'scout.scorecard.table.60l': '60L',
  'scout.scorecard.table.25l': '25L',
  'scout.scorecard.table.10l': '10L',
  'scout.scorecard.table.netRevenue': '純売上',
  'scout.scorecard.table.total': '合計',
  'scout.scorecard.topBranchen': '主要業種',
  'scout.scorecard.topProdukte': '主要製品',
  'scout.scorecard.table.industry': '業種',
  'scout.scorecard.table.quantity': '数量（ケース）',
  'scout.scorecard.table.revenue': '売上（€）',
  'scout.scorecard.table.product': '製品',
  'scout.scorecard.table.salesVolume': '販売数量',
  'scout.scorecard.table.customers': '顧客',
  'scout.scorecard.kpi.visits': '訪問',
  'scout.scorecard.kpi.demos': 'デモ',
  'scout.scorecard.kpi.orders': '受注',
  'scout.scorecard.kpi.netRevenue': '純売上',
  'scout.scorecard.kpi.gebinde60l': '60Lケース',
  'scout.scorecard.kpi.gebinde25l': '25Lケース',
  'scout.scorecard.kpi.gebinde10l': '10Lケース',
  'scout.scorecard.emptyTitle': 'データなし',
  'scout.scorecard.emptyDescription': '選択期間のKPIデータがありません。',
  'scout.scorecard.missionPerformanceTitle': 'ミッション実績',
  'scout.scorecard.missionMissionsCompleted': '完了ミッション',
  'scout.scorecard.missionConversionRate': 'コンバージョン率',
  'scout.scorecard.missionTerritoryCoverage': 'エリアカバー',
  'scout.scorecard.viewMissionDetails': '詳細を表示',
  'scout.scorecard.adjustTargets': '目標を調整',
  'scout.scorecard.annualTarget': '年間目標',
  'scout.scorecard.annualTargetVisits': '年間訪問目標',
  'scout.scorecard.annualTargetDemos': '年間デモ目標',
  'scout.scorecard.annualTargetNetRevenue': '純売上（€）',
  'scout.scorecard.annualTargetNetRevenueA11y': '年間純売上目標（ユーロ）',
  'scout.scorecard.monthlyOverrides': '月次上書き',
  'scout.scorecard.table.month': '月',
  'scout.scorecard.table.reason': '理由',
  'scout.scorecard.derivedTargets': '派生目標',
  'scout.scorecard.dailyTargetLabel': '日次目標: {{count}} 訪問',
  'scout.scorecard.weeklyTargetLabel': '週次目標: {{count}} 訪問',
  'scout.scorecard.save': '保存',
  'scout.scorecard.heatmap.visits': '訪問',
  'scout.scorecard.heatmap.demos': 'デモ',
  'scout.scorecard.heatmap.revenue': '売上',
  'scout.scorecard.heatmap.low': '少',
  'scout.scorecard.heatmap.high': '多',
  'scout.scorecard.heatmap.scaleA11y': '少から多への色スケール',
  'scout.scorecard.heatmap.loading': '地図を読み込み中…',
  'scout.scorecard.heatmapTitle': 'アクティビティヒートマップ（郵便番号2桁）',

  // Scout Mission Control
  'scout.missionControl.teamOverview': 'チームと郵便番号エリア',
  'scout.missionControl.jokerLimitPerDay': 'ジョーカー上限/日',
  'scout.missionControl.jokerLimitUpdated': 'ジョーカー上限を更新しました。',
  'scout.missionControl.jokerLimitSaveFailed': 'ジョーカー上限を保存できませんでした。',
  'scout.missionControl.selectTeam': 'チームを選択',
  'scout.missionControl.none': 'なし',
  'scout.missionControl.addPlzAreaFor': '郵便番号エリアを追加（対象: ',
  'scout.missionControl.addPlzArea': '郵便番号エリアを追加',
  'scout.missionControl.noTeamMembersFound': 'チームメンバーが見つかりません。',
  'scout.missionControl.orders': '受注',
  'scout.missionControl.resetSettings': '設定をリセット',
  'scout.missionControl.saveSettings': '設定を保存',
  'scout.missionControl.territorySaturation': 'エリア飽和度（郵便番号）',
  'scout.missionControl.day': '日',
  'scout.missionControl.selectDay': '日を選択',
  'scout.missionControl.week': '週',
  'scout.missionControl.selectWeek': '週を選択',
  'scout.missionControl.month': '月',
  'scout.missionControl.selectMonth': '月を選択',
  'scout.missionControl.planFulfillment': '計画達成',
  'scout.missionControl.plzPrefixPlaceholder': '郵便番号プレフィックス（例: 70）',
  'scout.missionControl.plzPrefix': '郵便番号プレフィックス',
  'scout.missionControl.addPlzToWhitelist': 'ホワイトリストに郵便番号プレフィックスを追加',
  'scout.missionControl.addPlzToGreylist': 'グレーリストに郵便番号プレフィックスを追加',
  'scout.missionControl.addPlzToYellowlist': 'イエローリストに郵便番号プレフィックスを追加',
  'scout.missionControl.addNewTeamMember': 'チームメンバーを追加',
  'scout.missionControl.lastModified': '最終更新',
  'scout.missionControl.outsideAreaRules': 'エリア外ルール',
  'scout.missionControl.outsidePlzPolicy': 'リスト外郵便番号のポリシー',
  'scout.missionControl.enableOutsideWarning': 'エリア外郵便番号の警告を有効にする',
  'scout.missionControl.requireOutsideApproval': 'エリア外郵便番号の承認を必須にする',
  'scout.missionControl.rejectOutsidePlz': 'エリア外郵便番号を拒否',
  'scout.missionControl.checkPlz': '郵便番号またはプレフィックスを確認',
  'scout.missionControl.check': '確認',
  'scout.missionControl.error': 'エラー',
  'scout.missionControl.success': '成功',
  'scout.missionControl.userProfileNotFound': 'ユーザープロファイルが見つかりません',
  'scout.missionControl.plzAreasUpdated': '郵便番号エリアを更新しました',
  'scout.missionControl.plzAreasSaveFailed': '郵便番号エリアを保存できませんでした',
  'scout.missionControl.repConfig.title': '担当者設定',
  'scout.missionControl.repConfig.repName': '名前 / メール',
  'scout.missionControl.repConfig.industries': '業種',
  'scout.missionControl.repConfig.products': '製品',
  'scout.missionControl.repConfig.plz': '郵便番号',
  'scout.missionControl.repConfig.loadError': '担当者設定を読み込めませんでした',
  'scout.missionControl.repConfig.saveError': '保存に失敗しました',
  'scout.missionControl.repConfig.savedTitle': '保存しました',
  'scout.missionControl.repConfig.savedDesc': '担当者設定を更新しました',
  'scout.missionControl.jokerConfig.title': '1日あたりのジョーカー上限',
  'scout.missionControl.jokerConfig.description': '担当者1人あたり1日のジョーカー使用上限。',
  'scout.missionControl.jokerConfig.maxPerDay': '1日最大',
  'scout.missionControl.jokerConfig.loadError': 'ジョーカー設定を読み込めませんでした',
  'scout.missionControl.jokerConfig.saveError': '保存に失敗しました',
  'scout.missionControl.jokerConfig.savedTitle': '保存しました',
  'scout.missionControl.jokerConfig.savedDesc': 'ジョーカー上限を更新しました',
  'scout.missionControl.diagnostics.demoRate': 'デモ率',
  'scout.missionControl.diagnostics.visitDepth': '訪問深度',
  'scout.unternehmenssuche.selectAllResults': '検索結果をすべて選択',
  'scout.unternehmenssuche.openingHours': '営業時間',
  'scout.unternehmenssuche.temporarilyClosed': '一時休業中',
  'scout.unternehmenssuche.startSearch': '検索開始',
  'scout.unternehmenssuche.searchRunning': '検索中...',
  'scout.unternehmenssuche.adjustSearchCriteria': '検索条件を変更するか、再試行してください。',
  'scout.unternehmenssuche.selectCompanyType': '企業タイプを選択',
  'scout.unternehmenssuche.openingHoursTime': '営業時間',
  'scout.unternehmenssuche.noTimeNeeded': '時刻不要',
  'scout.unternehmenssuche.addConditions': '条件を追加して検索を絞り込む',
  'scout.unternehmenssuche.addCondition': '条件を追加',
  'scout.unternehmenssuche.addGroup': 'グループを追加',
  'scout.unternehmenssuche.savedSearchName': '保存検索の名前',
  'scout.unternehmenssuche.saveCurrentSearch': '現在の検索を保存',
  'scout.unternehmenssuche.savedSearches': '保存した検索',
  'scout.unternehmenssuche.noSavedSearches': '保存した検索はありません。',
  'scout.unternehmenssuche.keywordPlaceholder': '例: レストラン、バー、パン屋',
  'scout.unternehmenssuche.addWaypoint': '経由地を追加',
  'scout.unternehmenssuche.locationPlaceholder': '例: ミュンヘン マリエン広場',
  'scout.unternehmenssuche.toggleAdditionalFilters': '追加フィルターの表示切替',
  'scout.unternehmenssuche.additionalFilters': '追加フィルター',
  'scout.unternehmenssuche.saveSearchAsFile': '検索をファイルに保存',
  'scout.unternehmenssuche.loadSearchFromFile': 'ファイルから検索を読み込み',
  'scout.unternehmenssuche.checkSearchTerms': '検索語を確認するか、再試行してください。',
  'search.overlay.hint': '入力して Enter または検索をクリック。',
  'search.overlay.placeholder': 'リソース・ドキュメント等を検索（/）',
  'search.overlay.searchLabel': '検索',
  'search.overlay.noResults': '「{{query}}」に一致する結果はありません',
  'search.overlay.tryDifferent': '別の語で検索するか、スペルを確認してください。',
  'search.overlay.topResults': 'おすすめ結果',
  'search.overlay.documentation': 'ドキュメント・',
  'scout.unternehmenssuche.locationRadius': '場所＋半径',
  'scout.unternehmenssuche.routeCorridor': 'ルート＋回廊',
  'scout.unternehmenssuche.withoutLocation': '場所なし',
  'scout.preferences.defaultRegionLabel': '既定地域',
  'scout.preferences.selectRegionPlaceholder': '地域を選択',
  'scout.preferences.defaultStatusLabel': '既定ステータス',
  'scout.preferences.selectDefaultStatus': '既定ステータスを選択',
  'scout.preferences.statusDraft': '下書き',
  'scout.preferences.statusActive': '有効',
  'scout.preferences.statusCompleted': '完了',
  'scout.preferences.statusArchived': 'アーカイブ',
  'scout.preferences.saving': '保存中...',
  'scout.preferences.plzPrefixes': 'ミッション用郵便番号プレフィックス',
  'scout.preferences.plzPrefixesPlaceholder': 'カンマ区切りで入力（例: 70, 71, 72）',
  'scout.preferences.maxRouteLength': '最大ルート長（km）',
  'scout.preferences.maxRouteLengthDescription': '最大ルート長（キロメートル）',
  'scout.preferences.autoGenerateMissions': 'ミッション自動生成（夜間バッチ）',
  'scout.preferences.autoGenerateDescription': '有効にすると、設定に基づきミッションが自動生成されます。',
  'scout.preferences.defaultAssigneeLabel': '既定担当者',
  'scout.preferences.defaultAssigneePlaceholder': '既定担当者を入力',
  'scout.preferences.defaultAssigneeAria': '既定担当者',
  'scout.preferences.defaultLeadCountLabel': '既定リード数',
  'scout.preferences.defaultLeadCountAria': '既定リード数',
  'scout.preferences.defaultDurationLabel': '既定期間（日）',
  'scout.preferences.defaultDurationAria': '既定期間（日）',
  'scout.preferences.autoAssignLabel': 'ミッションを既定担当者に自動割り当て',
  'scout.preferences.productFamiliesLabel': '製品ファミリー',
  'scout.preferences.industryCodesLabel': '業種',
  'scout.preferences.keywordsLabel': 'キーワード',
  'scout.preferences.keywordsPlaceholder': '例: コンクリート、床',
  'scout.preferences.minLeadsLabel': 'ミッションあたり最小リード数',
  'scout.preferences.minLeadsAria': 'ミッションあたり最小リード数',
  'scout.preferences.maxLeadsLabel': 'ミッションあたり最大リード数',
  'scout.preferences.maxLeadsAria': 'ミッションあたり最大リード数',
  'scout.preferences.dailyQuotaLabel': '1日あたりミッション数',
  'scout.preferences.dailyQuotaAria': '1日あたり最大ミッション数',
  'scout.preferences.dailyQuotaHelper': '1日あたり自動生成ミッション数（1〜3）',
  'scout.createMission.title': '新規ミッションを作成',
  'scout.createMission.description': '名前・フィルター・担当者を選択',
  'scout.createMission.nameLabel': '名前',
  'scout.createMission.nameRequired': '名前は必須です',
  'scout.createMission.namePlaceholder': '例: シュトゥットガルト北 — 冷凍設備',
  'scout.createMission.nameAria': 'ミッション名',
  'scout.createMission.regionLabel': '地域（任意）',
  'scout.createMission.regionPlaceholder': '例: 郵便番号 70xxx',
  'scout.createMission.regionAria': '地域または郵便番号',
  'scout.createMission.ownerLabel': 'オーナー',
  'scout.createMission.ownerPlaceholder': 'メールアドレス',
  'scout.createMission.ownerAria': 'オーナーメールアドレス',
  'scout.createMission.themeLabel': 'テーマ（任意）',
  'scout.createMission.themePlaceholder': '例: 冷凍設備',
  'scout.createMission.themeAria': 'ミッションテーマ',
  'scout.createMission.productLabel': '製品（任意）',
  'scout.createMission.productPlaceholder': '例: K-2000',
  'scout.createMission.productAria': '製品',
  'scout.createMission.cancel': 'キャンセル',
  'scout.createMission.save': '保存',
  'scout.createMission.saveBusy': '保存中…',
  'scout.createMission.cancelAria': 'ミッション作成をキャンセル',
  'scout.createMission.saveAria': 'ミッションを保存',
  'scout.createMission.saveBusyAria': 'ミッションを保存中',

  // Helpdesk / Tickets

  // Inventory

  // Sales

  // Purchase


  // Settings
  'settings.description': 'アプリ設定とカスタマイズを管理',
  'settings.typography.title': 'タイポグラフィ',
  'settings.typography.description': '可読性または情報密度のため文字サイズ・行間を調整',
  'settings.typography.scale.title': '文字サイズ',
  'settings.typography.scale.description': '標準はマスター基準。コンフォートは長時間用に拡大。',
  'settings.typography.scale.ariaLabel': '文字サイズプリセット',
  'settings.typography.scale.compact': 'コンパクト',
  'settings.typography.scale.standard': '標準',
  'settings.typography.scale.comfort': 'コンフォート',
  'settings.tabs.appearance': '外観',
  'settings.tabs.account': 'アカウント',
  'settings.tabs.notifications': '通知',
  'settings.tabs.security': 'セキュリティ',
  'settings.language.title': '言語設定',
  'settings.language.description': 'アプリの表示言語を選択',
  'settings.language.interfaceLanguage': 'インターフェース言語',
  'settings.language.interfaceLanguageDesc': 'メニュー・ボタン・UIの言語',
  'settings.theme.title': 'カラースキーム',
  'settings.theme.description': '外観と色を調整',
  'settings.theme.predefinedThemes': '10種類のプリセットから選びますか？',
  'settings.theme.goToThemeSettings': 'テーマ設定へ',
  'settings.themeSettings.title': 'テーマ設定',
  'settings.themeSettings.description': 'プリセットでアプリの外観を調整',
  'settings.themeSettings.themeDetails': 'テーマ詳細',
  'settings.themeSettings.themeId': 'テーマID:',
  'settings.themeSettings.colorScheme': 'カラースキーム:',
  'settings.account.profile.title': 'プロフィール',
  'settings.account.profile.description': '個人情報とアカウントを更新',
  'settings.account.profile.name': '名前',
  'settings.account.profile.email': 'メール',
  'settings.account.profile.role': 'ロール',
  'settings.account.profile.department': '部門',
  'settings.account.profile.editProfile': 'プロフィールを編集',
  'settings.account.data.title': 'データ管理',
  'settings.account.data.description': '同期とバックアップ設定を管理',
  'settings.account.data.cloudSync': 'クラウド同期',
  'settings.account.data.cloudSyncEnabled': '設定はクラウドに同期されます',
  'settings.account.data.cloudSyncDisabled': 'クラウド同期は無効です（機能フラグ）',
  'settings.account.data.syncNow': '今すぐ同期',
  'settings.notifications.title': '通知設定',
  'settings.notifications.description': '通知の受け取り方法を設定',
  'settings.notifications.email.title': 'メール通知',
  'settings.notifications.email.description': 'メールで通知を受け取る',
  'settings.notifications.push.title': 'プッシュ通知',
  'settings.notifications.push.description': 'ブラウザでプッシュ通知を受け取る',
  'settings.notifications.system.title': 'システム警告',
  'settings.notifications.system.description': '重要なシステム通知',
  'settings.notifications.configure': '設定',
  'settings.security.title': 'セキュリティ設定',
  'settings.security.description': 'アカウントのセキュリティとプライバシーを管理',
  'settings.security.password.title': 'パスワード',
  'settings.security.password.lastChanged': '30日以上前に変更',
  'settings.security.password.change': '変更',
  'settings.security.twoFactor.title': '二要素認証',
  'settings.security.twoFactor.description': '追加の認証層',
  'settings.security.twoFactor.enable': '有効にする',
  'settings.security.sessions.title': 'セッション管理',
  'settings.security.sessions.description': 'アクティブなセッションを管理',
  'settings.security.sessions.view': 'セッションを表示',
  'settings.company.title': '会社設定',
  'settings.company.description': '会社情報と設定を管理',
  'settings.company.edit': '会社を編集',
  'settings.company.saveChanges': '変更を保存',
  'settings.company.cancel': 'キャンセル',
  'settings.company.tabs.general': '一般',
  'settings.company.tabs.contact': '連絡先',
  'settings.company.tabs.billing': '請求',
  'settings.company.tabs.branding': 'ブランディング',
  'settings.company.general.companyInfo': '会社情報',
  'settings.company.general.companyName': '会社名',
  'settings.company.general.legalName': '正式名称',
  'settings.company.general.taxId': '税番',
  'settings.company.general.registrationNumber': '登記番号',
  'settings.company.general.industry': '業種',
  'settings.company.general.foundedYear': '設立年',
  'settings.company.general.employees': '従業員数',
  'settings.company.general.industry.technology': 'テクノロジー',
  'settings.company.general.industry.manufacturing': '製造',
  'settings.company.general.industry.retail': '小売',
  'settings.company.general.industry.healthcare': 'ヘルスケア',
  'settings.company.general.industry.finance': '金融',
  'settings.company.general.industry.other': 'その他',
  'settings.company.address.title': '住所',
  'settings.company.address.street': '住所',
  'settings.company.address.city': '市区町村',
  'settings.company.address.state': '都道府県',
  'settings.company.address.zipCode': '郵便番号',
  'settings.company.address.country': '国',
  'settings.company.address.country.us': 'アメリカ',
  'settings.company.address.country.ca': 'カナダ',
  'settings.company.address.country.uk': 'イギリス',
  'settings.company.address.country.de': 'ドイツ',
  'settings.company.address.country.fr': 'フランス',
  'settings.company.address.country.other': 'その他',
  'settings.company.contact.title': '連絡先',
  'settings.company.contact.phone': '電話',
  'settings.company.contact.email': 'メール',
  'settings.company.contact.website': 'ウェブサイト',
  'settings.company.contact.supportEmail': 'サポートメール',
  'settings.company.billing.title': '請求設定',
  'settings.company.billing.currency': '通貨',
  'settings.company.billing.taxRate': '税率（%）',
  'settings.company.billing.paymentTerms': '支払条件',
  'settings.company.billing.billingCycle': '請求サイクル',
  'settings.company.billing.paymentTerms.net15': 'Net 15',
  'settings.company.billing.paymentTerms.net30': 'Net 30',
  'settings.company.billing.paymentTerms.net45': 'Net 45',
  'settings.company.billing.paymentTerms.net60': 'Net 60',
  'settings.company.billing.paymentTerms.dueOnReceipt': '受領時払い',
  'settings.company.billing.cycle.monthly': '月次',
  'settings.company.billing.cycle.quarterly': '四半期',
  'settings.company.billing.cycle.annually': '年次',
  'settings.company.billing.cycle.custom': 'カスタム',
  'settings.company.billing.summary.title': '請求概要',
  'settings.company.billing.summary.currentPlan': '現在のプラン',
  'settings.company.billing.summary.monthlyCost': '月額',
  'settings.company.billing.summary.nextBillingDate': '次回請求日',
  'settings.company.billing.summary.paymentMethod': '支払方法',
  'settings.company.billing.summary.status': 'ステータス',
  'settings.company.billing.summary.active': '有効',
  'settings.company.branding.title': 'ブランディング',
  'settings.company.branding.logo': 'ロゴ',
  'settings.company.branding.uploadLogo': 'ロゴをアップロード',
  'settings.company.branding.logoHint': 'PNG、JPG 最大2MB',
  'settings.company.branding.favicon': 'ファビコン',
  'settings.company.branding.uploadFavicon': 'ファビコンをアップロード',
  'settings.company.branding.faviconHint': 'ICO、PNG 最大1MB',
  'settings.company.branding.primaryColor': 'プライマリ色',
  'settings.company.branding.secondaryColor': 'セカンダリ色',
  'settings.usersRoles.stats.totalUsers': 'ユーザー合計',
  'settings.usersRoles.stats.activeUsers': 'アクティブユーザー',
  'settings.usersRoles.stats.totalRoles': 'ロール合計',
  'settings.usersRoles.stats.roleConfigurations': 'ロール設定',
  'settings.userManagement.title': 'ユーザー管理',
  'settings.userManagement.description': 'ユーザー・ロール・システム設定を管理',
  'settings.userManagement.addUser': 'ユーザーを追加',
  'settings.userManagement.editUser': 'ユーザーを編集',
  'settings.userManagement.createNewUser': '新規ユーザーを作成',
  'settings.userManagement.updateUserInfo': 'ユーザー情報を更新',
  'settings.userManagement.addNewUser': '新規ユーザーを追加',
  'settings.userManagement.tabs.users': 'ユーザー',
  'settings.userManagement.tabs.appAccess': 'アプリアクセス',
  'settings.userManagement.tabs.roles': 'ロール',
  'settings.userManagement.toast.userCreated': 'ユーザーを作成しました',
  'settings.userManagement.toast.userUpdated': 'ユーザーを更新しました',
  'settings.userManagement.toast.userDeleted': 'ユーザーを削除しました',
  'settings.userManagement.toast.roleCreated': 'ロールを作成しました',
  'settings.userManagement.toast.roleUpdated': 'ロールを更新しました',
  'settings.userManagement.toast.roleDeleted': 'ロールを削除しました',
  'settings.userManagement.toast.error': 'ユーザーを作成できませんでした',
  'settings.userManagement.toast.errorUpdate': 'ユーザーを更新できませんでした',
  'settings.userManagement.toast.errorDelete': 'ユーザーを削除できませんでした',
  'settings.userManagement.toast.errorRoleCreate': 'ロールを作成できませんでした',
  'settings.userManagement.toast.errorRoleUpdate': 'ロールを更新できませんでした',
  'settings.userManagement.toast.errorRoleDelete': 'ロールを削除できませんでした',
  'settings.integrations.settings.security.enabled': '有効',
  'settings.integrations.settings.security.disabled': '無効',

  // Analytics - Pivot Table

  // Reports

  // Warehouse - Picking

  // Warehouse - Returns

  // Warehouse - ASN

  // CRM - Contacts
  'crm.contacts.title': 'CRM連絡先',
  'crm.contacts.description': '顧客・サプライヤー連絡先と住所を管理',
  'crm.contacts.add': '連絡先を追加',
  'crm.contacts.edit': '連絡先を編集',
  'crm.contacts.delete': '連絡先を削除',
  'crm.contacts.view360': '360°ビュー',
  'crm.contacts.unassigned': '未割り当て',
  'crm.contacts.type.customer': '顧客',
  'crm.contacts.type.supplier': 'サプライヤー',
  'crm.contacts.type.partner': 'パートナー',
  'crm.contacts.type.prospect': '見込み',
  'crm.contacts.status.active': '有効',
  'crm.contacts.status.inactive': '無効',
  'crm.contacts.status.suspended': '停止',
  'crm.contacts.validation.companyRequired': '会社名は必須です',
  'crm.contacts.validation.streetRequired': '住所は必須です',
  'crm.contacts.validation.postalRequired': '郵便番号は必須です',
  'crm.contacts.validation.cityRequired': '市区町村は必須です',
  'crm.contacts.validation.countryRequired': '国は必須です',
  'crm.contacts.validation.nameRequired': '連絡先名は必須です',
  'crm.contacts.validation.emailInvalid': '有効なメールアドレスを入力してください',
  'crm.contacts.validation.phoneRequired': '電話番号は必須です',
  'crm.contacts.validation.salesPersonRequired': '営業担当は必須です',
  'crm.contacts.validation.ordererNameRequired': '発注者名は必須です',
  'crm.contacts.validation.roleRequired': 'ロールは必須です',
  'crm.contacts.validation.hoursRequired': '時間は必須です',
  'crm.openMenu': 'メニューを開く',

  // CRM - Leads
  'crm.leads.title': 'リード',
  'crm.leads.description': 'リードとコンバージョンを管理',
  'crm.leads.add': 'リードを追加',
  'crm.leads.edit': 'リードを編集',
  'crm.leads.delete': 'リードを削除',
  'crm.leads.status.new': '新規',
  'crm.leads.status.contacted': '接触済み',
  'crm.leads.status.qualified': '認定',
  'crm.leads.status.proposal': '提案',
  'crm.leads.status.negotiation': '交渉中',
  'crm.leads.status.closedWon': '受注',
  'crm.leads.status.closedLost': '失注',
  'crm.leads.source.website': 'ウェブサイト',
  'crm.leads.source.referral': '紹介',
  'crm.leads.source.email': 'メール',
  'crm.leads.source.phone': '電話',
  'crm.leads.source.social': 'SNS',
  'crm.leads.source.other': 'その他',
  'crm.leads.value': '金額',
  'crm.leads.lastContact': '最終接触',
  'crm.leads.notes': 'メモ',
  'crm.leads.search': 'リードを検索...',
  'crm.leads.filterByStatus': 'ステータスで絞り込み',
  'crm.leads.filterBySource': 'ソースで絞り込み',
  'crm.leads.totalLeads': 'リード合計',
  'crm.leads.pipelineValue': 'パイプライン金額',
  'crm.leads.qualifiedLeads': '認定リード',
  'crm.leads': 'リード',
  'crm.closedWon': '受注',
  'crm.searchPlaceholder': 'リードを検索...',
  'crm.name': '名前',
  'crm.company': '会社',
  'crm.contact': '連絡先',
  'crm.source': 'ソース',
  'crm.value': '金額',
  'crm.lastContact': '最終接触',
  'crm.viewDetails': '詳細を表示',
  'crm.editLead': 'リードを編集',
  'crm.addNote': 'メモを追加',
  'crm.convertToCustomer': '顧客にコンバート',
  'crm.deleteLead': 'リードを削除',
  'crm.leadDetails': 'リード詳細',
  'crm.addNewLead': '新規リードを追加',
  'crm.viewLeadDetails': 'リード詳細を表示',
  'crm.createNewLead': '新規リードを作成',
  'crm.fullName': '氏名',
  'crm.email': 'メール',
  'crm.phone': '電話',
  'crm.estimatedValue': '見積金額',
  'crm.notes': 'メモ',
  'crm.status.new': '新規',
  'crm.status.contacted': '接触済み',
  'crm.status.qualified': '認定',
  'crm.status.proposal': '提案',
  'crm.status.negotiation': '交渉中',
  'crm.status.closedWon': '受注',
  'crm.status.closedLost': '失注',
  'crm.source.website': 'ウェブサイト',
  'crm.source.referral': '紹介',
  'crm.source.tradeShow': '展示会',
  'crm.source.coldCall': 'コールドコール',
  'crm.source.socialMedia': 'SNS',
  'crm.source.emailCampaign': 'メールキャンペーン',

  // Visit Report
  'visitReport.title': '訪問レポート',
  'visitReport.createTitle': '訪問レポートを作成',
  'visitReport.titleFor': '{{name}} の訪問レポート',
  'visitReport.visitType': '訪問タイプ',
  'visitReport.coldVisit': 'コールド訪問',
  'visitReport.appointment': 'アポイント',
  'visitReport.salesOutcome': '営業結果',
  'visitReport.noContact': '接触なし',
  'visitReport.conversation': '会話',
  'visitReport.demo': 'デモ',
  'visitReport.order': '受注',
  'visitReport.orderValue': '受注金額（EUR）',
  'visitReport.nextStep': '次のアクション',
  'visitReport.callback': 'コールバック',
  'visitReport.sendOffer': '提案書送付',
  'visitReport.revisit': '再訪問',
  'visitReport.completed': '完了',
  'visitReport.appointmentWindow': '予定枠（任意）',
  'visitReport.from': '開始',
  'visitReport.to': '終了',
  'visitReport.contactName': '担当者名',
  'visitReport.enterName': '名前を入力',
  'visitReport.roleFunction': '役職・役割',
  'visitReport.enterRole': '役職を入力',
  'visitReport.isDecisionMaker': '決裁者ですか？',
  'visitReport.decisionMakerName': '決裁者名',
  'visitReport.decisionMakerRole': '決裁者役職',
  'visitReport.email': 'メール（任意）',
  'visitReport.phone': '電話（任意）',
  'visitReport.notes': 'メモ（任意）',
  'visitReport.additionalInfo': 'その他...',
  'visitReport.productsDiscussed': '話題にした製品',
  'visitReport.annualDemand': '年間需要',
  'visitReport.select': '選択',
  'visitReport.interest': '関心度',
  'visitReport.interestHigh': '高',
  'visitReport.interestMedium': '中',
  'visitReport.interestLow': '低',
  'visitReport.modelFeedback': 'システムの提案は適切でしたか？',
  'visitReport.feedbackYes': 'はい',
  'visitReport.feedbackPartially': '一部',
  'visitReport.feedbackNo': 'いいえ',
  'visitReport.feedbackNotSeen': '見ていない',
  'visitReport.branchCorrect': '業種は正しいですか？（任意）',
  'visitReport.selectBranch': '業種を選択',
  'visitReport.branchConstruction': '建設',
  'visitReport.branchIndustry': '製造',
  'visitReport.branchTrade': '商業',
  'visitReport.branchService': 'サービス',
  'visitReport.noInterestReason': '関心がない理由',
  'visitReport.wrongProduct': '製品が合わない',
  'visitReport.wrongTiming': 'タイミングが合わない',
  'visitReport.existingSupplier': '既存サプライヤーあり',
  'visitReport.noBudget': '予算なし',
  'visitReport.noNeed': 'ニーズなし',
  'visitReport.decisionMakerNotReached': '決裁者に接触できず',
  'visitReport.additionalRemarks': 'その他（任意）',
  'visitReport.error': 'エラー',
  'visitReport.validationError': '訪問タイプと営業結果を選択してください。',
  'visitReport.deferralNotPossible': '先送りできません',
  'visitReport.maxDeferralReached': '最後のレポートはすでに先送り済みです。入力を完了してください。',
  'visitReport.reportDeferred': 'レポートを先送りしました',
  'visitReport.deferralMessage': '後で入力できます。',
  'visitReport.reportCreated': '訪問レポートを作成しました',
  'visitReport.reportSaved': '訪問レポートを保存しました。',
  'visitReport.reportSavedFor': '{{name}} の訪問レポートを保存しました。',
  'visitReport.reportError': '訪問レポートを作成できませんでした。',
  'visitReport.stepOf': 'ステップ {{current}} / {{total}}',
  'visitReport.back': '戻る',
  'visitReport.cancel': 'キャンセル',
  'visitReport.inAHurry': '急いでいます',
  'visitReport.next': '次へ',
  'visitReport.saving': '保存中...',
  'visitReport.finishVisit': '訪問を完了',
  'visitReport.contactNotes': '担当者に関する補足...',
  'visitReport.callingQueue.prompt': 'このリード用にAIアポコールをキューに追加しますか？',
  'visitReport.callingQueue.yes': 'はい、キューに追加',
  'visitReport.callingQueue.no': 'いいえ',
  'visitReport.callingQueue.toast': 'リードをコールキューに追加しました。',

  // Visit Report — Rejection / Compliance (Scout)
  'scout.visitReport.compliance.title': '未入力の訪問レポート',
  'scout.visitReport.compliance.description': '未入力の訪問レポートが {{count}} 件あります。先に入力してください。',
  'scout.visitReport.compliance.lockoutTitle': 'レポート入力が必要です',
  'scout.visitReport.compliance.lockoutDescription': '続行するには未入力の訪問レポートをすべて入力してください。',
  'scout.visitReport.compliance.deferButton': '後で入力',
  'scout.visitReport.compliance.deferCount': '残り {{remaining}} 回まで先送り可能',
  'scout.visitReport.compliance.noDeferrals': '先送り回数が残っていません',
  'scout.visitReport.compliance.fillReport': 'レポートを入力',
  'scout.visitReport.compliance.morningLockout': '未入力レポートをすべて入力するまで日次計画は利用できません。',

  // Admin (SS-145)
  'app.routes.loadingSettings': '設定を読み込み中...',
  'companySearch.filters.companySize': '企業規模',
  'curriculum.modules.pillar': '柱',
  'curriculum.modules.selectLevel': 'レベルを選択',
  'curriculum.modules.selectPillar': '柱を選択',
  'curriculum.modules.selectPillarOption': '柱を選択',
  'learning.lessonViewer.audioNotSupported': 'お使いのブラウザは音声をサポートしていません。',
  'learning.lessonViewer.complete': '完了',
  'learning.lessonViewer.formatNotSupported': '非対応形式',
  'learning.lessonViewer.videoNotSupported': 'お使いのブラウザは動画をサポートしていません。',
  'learning.moduleEditor.pillar': '柱',
  'learning.moduleEditor.pillarLabel': '柱',
  'learning.tabs.availableLessons': '利用可能なレッスン',
  'learning.tabs.availableQuizzes': '利用可能なクイズ',
  'missions.management.demoPerformed': 'デモ実施済み',
  'missions.management.demoPerformedLabel': 'デモ実施済み',
  'missions.management.kpiDescription': '決裁者接触・デモ実施・売上',
  'missions.management.moreActions': 'ミッションのその他操作を表示',
  'missions.management.publish': '公開',
  'missions.management.searchPlaceholder': '検索（名前/地域/テーマ/製品）',
  'mobile.layout.closeMenu': 'メニューを閉じる',
  'mobile.layout.menu': 'メニュー',
  'mobile.layout.noOfflineContent': 'オフラインコンテンツはありません',
  'mobile.layout.offlinePerformance': 'オフラインで快適に利用',
  'navigation.tileCard.openActions': 'タイルの操作を開く',
  'scout.preferences.badenWuerttemberg': 'バーデン＝ヴュルテンベルク',
  'scout.preferences.thueringen': 'テューリンゲン',
  'scout.sprints.ciEstimate': 'CI所要時間見積もり',
  'scout.sprints.estimatedMinutes': '見積分数',
  'styleGuide.charts.noStatusColors': 'チャートではステータス色を使用しない',
  'styleGuide.confirmation': '確認',
  'styleGuide.description': '説明',
  'styleGuide.statusSemantics.success': '成功 = 完了/OK',
  'tickets.list.filterPriority': '優先度で絞り込み',
  'ui.calendar.nextMonth': '翌月',
  'ui.errorBoundary.returnToDashboard': 'ダッシュボードに戻る',
  'ui.impersonation.selectImpersonation': 'なりすましを選択',
  'ui.impersonation.selectUser': 'ユーザーを選択:',
  'ui.routingPreview.openAppleMaps': 'Appleマップで開く',
  'ui.routingPreview.openGoogleMaps': 'Googleマップで開く',
  'ui.routingPreview.stopsLabel': '{{count}} 停・{{distance}} km・約{{time}} 分',
  'ui.routingPreview.title': 'ルートプレビュー',
  'weeklyPlanning.appointmentModal.additionalNotes': '追加メモ',
  'weeklyPlanning.legacyAppointments.addAppointment': '予定を追加',
  'scout.help.selectArticle': '左で記事を選ぶか、検索でヘルプ記事を開いてください。',

  // Learning — Lehrplan & Curriculum
  'learning.lehrplan.title': 'カリキュラム',
  'learning.lehrplan.subtitle': 'カリキュラムと学習目標を管理',
  'learning.curriculumPlanning.title': 'カリキュラム計画',
  'learning.curriculumPlanning.subtitle': 'カリキュラム構成と学習コンテンツの割り当て',

  // Modals
  'modals.assignMissionModal.close': '閉じる',
  'modals.assignMissionModal.searchPlaceholder': '検索（タイトル/業種）',
  'modals.assignMissionModal.searchAriaLabel': '検索',
  'modals.missionQuickViewModal.description': 'ミッションの簡易表示。詳細はミッション画面で。',
  'modals.missionQuickViewModal.close': '閉じる',
  'modals.missionQuickViewModal.openDetails': '詳細を開く',
  'modals.missionQuickViewModal.openDetailsAria': 'ミッション詳細を開く',
  'modals.leadDetailModal.close': '閉じる',
  'modals.leadDetailModal.whoIsThis': '誰ですか？',
  'modals.leadDetailModal.whatDoTheyNeed': '何が必要ですか？',
  'modals.leadDetailModal.whatDoISay': '何を話しますか？',
  'modals.leadDetailModal.moreProducts': 'その他製品',
  'modals.regionDetailsModal.description': 'ミッション詳細（読み取り専用）',
  'modals.regionDetailsModal.edit': '編集',
  'modals.regionDetailsModal.close': '閉じる',
  'modals.editRegionModal.close': '閉じる',
  'modals.editRegionModal.description': 'ミッションの時間とメモを編集。ステータスは読み取り専用。',
  'modals.editRegionModal.statusReadonlySrOnly': 'ステータスは読み取り専用。',
  'modals.splitAssignmentDialog.actionLabel': '操作を選択',
  'modals.splitAssignmentDialog.confirmButton': '確認',
  'modals.addAppointmentModal.companyAriaLabel': '会社/リードを選択または入力',
  'modals.addAppointmentModal.commitmentConfirmed': '確認済み',
  'modals.rejectLead.title': 'リードを拒否',
  'modals.rejectLead.closeAria': 'ダイアログを閉じる',
  'modals.rejectLead.description': '拒否理由を1つ以上選択してください。',
  'modals.rejectLead.reasonsLabel': '拒否理由',
  'modals.rejectLead.reasonsError': '少なくとも1つ選択してください。',
  'modals.rejectLead.otherReasonLabel': 'その他',
  'modals.rejectLead.otherReasonPlaceholder': '理由を入力...',
  'modals.rejectLead.otherReasonAria': 'その他の拒否理由',
  'modals.rejectLead.otherReasonError': '理由を入力してください。',
  'modals.rejectLead.cancel': 'キャンセル',
  'modals.rejectLead.confirm': '拒否（{count}）',
  'modals.rejectLead.reason.outOfBusiness': '廃業',
  'modals.rejectLead.reason.temporarilyClosed': '一時休業',
  'modals.rejectLead.reason.knownAndUnsuitable': '既知で不適切',
  'modals.rejectLead.reason.noInterest': '関心なし',
  'modals.rejectLead.reason.wrongContact': '担当者誤り',
  'modals.rejectLead.reason.other': 'その他',

  // Navigation, PO Sprints, Common, Scout aggregates
  'navigation.appOverview': 'アプリ概要',
  'common.next': '次へ',

  // Supplier onboarding — Form (CompanyInfoSection, ContactInfoSection, DocumentUploadSection)
  'country.US': 'アメリカ',
  'country.CA': 'カナダ',
  'country.MX': 'メキシコ',
  'country.GB': 'イギリス',
  'country.DE': 'ドイツ',
  'country.FR': 'フランス',
  'country.other': 'その他',

  // Missing keys (added from en/de)
  'common.saving': '保存中…',
  'common.archive': 'アーカイブ',
  'scout.search.selectStatus': 'ステータスを選択...',
  'scout.dailyPlanning.jokerAdd': 'ジョーカーを使用',
  'scout.dailyPlanning.jokerTitle': 'ジョーカー停',
  'scout.dailyPlanning.jokerUsed': '使用済み',
  'scout.dailyPlanning.jokerLimitReached': '本日のジョーカー停の上限に達しました。',
  'scout.dailyPlanning.jokerCompany': '会社',
  'scout.dailyPlanning.jokerCompanyPlaceholder': '会社名を入力',
  'scout.dailyPlanning.jokerReason': '理由',
  'scout.dailyPlanning.jokerReasonPlaceholder': 'この停はなぜ必要ですか？',
  'scout.dailyPlanning.jokerCancel': 'キャンセル',
  'scout.dailyPlanning.jokerSubmit': 'ジョーカーを使用',
  'scout.dailyPlanning.jokerCreateError': 'ジョーカー停を作成できませんでした。',
  'missions.management.decisionMakerMet': '決定者と面談',
  'missions.management.wonAmount': '獲得金額',
  'common.active': 'アクティブ',
  'common.archived': 'アーカイブ済み',
  'common.planned': '予定',
  'missionControl.totalLeads': 'リード合計',
  'missionControl.completedLeads': '完了リード',

  'survey.contact.name': '氏名',
  'survey.contact.namePlaceholder': '氏名を入力',
  'survey.contact.function': '役職 / 役割',
  'survey.contact.functionPlaceholder': '役職を入力',
  'survey.contact.email': 'メール',
  'survey.contact.emailPlaceholder': 'メールアドレスを入力',
  'survey.contact.phone': '電話',
  'survey.contact.phonePlaceholder': '電話番号を入力',
  'survey.contact.isDecisionMaker': '決裁者ですか？',
}
